import { FC } from 'react';

import SearchColumnDropdownPicker from './SearchInput/SearchColumnDropdownPicker';
import SearchInput from './SearchInput/SearchInput';
import { SearchExecutionMode } from '../../../../../enum/SearchExecutionMode';

interface SearchBarProps {
  hasSearchColumnDropdownPicker?: boolean;
  shouldAutocompleteSearch?: boolean;
  mode: SearchExecutionMode;
}

const SearchBar: FC<SearchBarProps> = ({
  hasSearchColumnDropdownPicker = true,
  shouldAutocompleteSearch = false,
  mode,
}) => {
  return (
    <div className="option_header">
      <SearchInput shouldAutocompleteSearch={shouldAutocompleteSearch} mode={mode}></SearchInput>
      {hasSearchColumnDropdownPicker && <SearchColumnDropdownPicker />}
    </div>
  );
};

export default SearchBar;
